import { render, staticRenderFns } from "./Suspected.vue?vue&type=template&id=14924ccc&"
import script from "./Suspected.vue?vue&type=script&lang=ts&"
export * from "./Suspected.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('14924ccc')) {
      api.createRecord('14924ccc', component.options)
    } else {
      api.reload('14924ccc', component.options)
    }
    module.hot.accept("./Suspected.vue?vue&type=template&id=14924ccc&", function () {
      api.rerender('14924ccc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Card/History/Suspected.vue"
export default component.exports